'use client';

import type { AnalyticsPlatformContext } from '../hooks/analytics/useAnalyticsEvent';
import { createSafeContext } from './createSafeContext';

export const [AnalyticsPlatformProvider, useAnalyticsPlatformContext] =
  createSafeContext<AnalyticsPlatformContext>('AnalyticsPlatformContext');
